// extracted by mini-css-extract-plugin
module.exports = {"title":"our-works-section_title__5l6Cp","subtitle":"our-works-section_subtitle__3GiEL"};